import { LoadingButton } from '@mui/lab'
import {
  BrandStyled,
  TopBarInnerStyled,
  TopBarRightStyled,
  TopBarStyled
} from '../onboardingStyles'

interface IOnboardingTopBar {
  email: string
  initials: string
  onSignOut: () => void
}

export const OnboardingTopBar = ({ email, initials, onSignOut }: IOnboardingTopBar) => (
  <TopBarStyled>
    <TopBarInnerStyled>
      <BrandStyled aria-label="Nutrisense">
        <img src="/logo.svg" alt="Nutrisense" />
        <span className="pipe" aria-hidden="true" />
        <span className="crumb">Coach onboarding</span>
      </BrandStyled>
      <TopBarRightStyled>
        <span className="user-chip">
          <span className="avatar" aria-hidden="true">
            {initials}
          </span>
          <span>{email}</span>
        </span>
        <LoadingButton size="small" color="inherit" onClick={onSignOut}>
          Sign out
        </LoadingButton>
      </TopBarRightStyled>
    </TopBarInnerStyled>
  </TopBarStyled>
)
